export const copyText = id => {
  // Check the user has no selected text already
  const selection = window.getSelection().toString();
  if (selection !== "") return;
  
  const copyText = document.getElementById(id);
  copyText.select();
  document.execCommand("copy");
};